import { useState } from 'react';
import Icon from '../components/Icon';

export const COMMON_FOODS = ['Tôm', 'Hành sống', 'Đồ cay', 'Sữa bò', 'Đậu phộng', 'Hải sản'];

// "Bạn không ăn được": common foods as chips plus "+ Thêm" for anything else. Picked chips are red with ✕.
export default function AvoidFoods({ value, onChange }) {
  const [adding, setAdding] = useState(false);
  const [text, setText] = useState('');
  const has = (food) => value.some((v) => v.toLowerCase() === food.toLowerCase());
  const toggle = (food) => onChange(has(food) ? value.filter((v) => v.toLowerCase() !== food.toLowerCase()) : [...value, food]);
  const chips = [...COMMON_FOODS, ...value.filter((v) => !COMMON_FOODS.some((c) => c.toLowerCase() === v.toLowerCase()))];
  const add = () => {
    const food = text.trim();
    if (food && !has(food)) onChange([...value, food]);
    setText('');
    setAdding(false);
  };
  return (
    <div className="flex flex-wrap gap-2">
      {chips.map((food) => (
        <button key={food} type="button" aria-pressed={has(food)} onClick={() => toggle(food)}
          className={`flex h-9 items-center gap-1 rounded-full border px-3 text-sm font-semibold ${has(food) ? 'border-[#e5484d] bg-[#fdecec] text-[#b42318]' : 'border-line bg-base-100'}`}>
          {has(food) && <Icon name="x" className="size-3.5" />}{food}
        </button>
      ))}
      {adding ? (
        <span className="flex items-center gap-1">
          <input autoFocus className="input input-sm h-9 w-32 rounded-full border-line" maxLength={40} value={text} placeholder="Tên món"
            onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} />
          <button type="button" className="btn btn-sm h-9 rounded-full" onClick={add}>Thêm</button>
        </span>
      ) : (
        <button type="button" className="flex h-9 items-center gap-1 rounded-full border border-dashed border-line px-3 text-sm font-semibold"
          onClick={() => setAdding(true)}>
          <Icon name="plus" className="size-3.5" /> Thêm
        </button>
      )}
    </div>
  );
}
